<template>
  <div class="login">
  </div>
</template>

<script>
import Vue from 'vue'
import { Dialog,Toast  } from 'vant';

Vue.use(Dialog)

export default {
  components: {
    Dialog
  },
  data() {
    return {
      active: 0
    };
  },
  async mounted(){  
    this.$sysUtil.wechatLogin();
  },
  methods: {
  }
};
</script>
